export default {"src":"/_next/static/media/right-arrow-white.d761e252.svg","height":16,"width":17};